import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import React from 'react';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { TABLET_BREAKPOINT } from '../../Constants/constant';

const useStyles = makeStyles((theme) => ({
  padding: {
    padding: '16px 16px 0px 16px',
  },
  submitBtn: {
    background: '#041e39 !important',
    color: 'white !important',
  },
  saveBtn: {
    gap: '10px',
    'border-radius': '4px',
    'font-style': 'normal',
    'font-weight': '500 !important',
    'font-size': '14px !important',
    'line-height': '100% !important',
    display: 'flex',
    'text-align': 'center',
    color: '#F15A2B !important',
    backgroundColor: 'transparent !important',
    padding: '8px',
    width: '100px',
    height: '38px',
    border: '1px solid #F15A2B',
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      width: 80,
    },
  },
  nextBtn: {
    display: 'flex',
    padding: '8px',
    gap: '8px',
    width: '100px',
    height: '38px',
    background: '#F15A2B !important',
    color: 'white !important',
    'border-radius': '4px',
    'font-style': 'normal',
    'font-weight': '500 !important',
    'font-size': '14px !important',
    'line-height': '100% !important',
    'text-align': 'center',
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      marginRight: '16px',
      width: 80,
    },
  },
}));

export default function KenDialog(props) {
  const {
    open,
    toggleOpen,
    handleClose,
    title,
    dialogText,
    negativeButtonText,
    positiveButtonText,
    negativeButtonProps,
    positiveButtonProps,
    dialogContent,
    dialogActions,
    children,
    titleContainerStyles,
    maxWidth,
    dialogActionProps,
    negativeButtonClick,
    positiveButtonClick,
    negativeBtnType,
    positiveButtonLabelProps,
    negativeButtonLabelProps,
    hidePositiveButton,
    hideNegativeButton,
    Component,
    innerProps,
    maxHeight,
    onClose,
    minWidth = '362px',
  } = props;

  const [onPositiveButtonClick, setOnPositiveButtonClick] = React.useState(() => positiveButtonClick);
  const [onNegativeButtonClick, setOnNegativeButtonClick] = React.useState(
    () =>
      negativeButtonClick ||
      (() => {
        toggleOpen(false);
      })
  );
  const [positiveButtonClickChange, setPositiveButtonClickChange] = React.useState(0);

  const compRef = React.useRef();

  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      PaperProps={{
        style: {
          minWidth: minWidth,
          maxHeight: maxHeight,
        },
      }}
      fullWidth
      maxWidth={maxWidth}
    >
      <DialogTitle id="form-dialog-title" classes={{ root: classes.padding }} style={{ ...titleContainerStyles }}>
        {title}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      {dialogContent || <>{dialogText && <DialogContent classes={{ root: classes.padding }}>{dialogText && <DialogContentText>{dialogText}</DialogContentText>}</DialogContent>}</>}
      <DialogContent classes={{ root: classes.padding }}>
        {children ? children : null}
        {Component && (
          <>
            <Component
              {...innerProps}
              setOnPositiveButtonClick={setOnPositiveButtonClick}
              setOnNegativeButtonClick={setOnNegativeButtonClick}
              // setIsOpen={setIsOpen}
              isOpen={open}
              toggleOpen={toggleOpen}
              ref={compRef}
              positiveButtonClickChange={positiveButtonClickChange}
            />
          </>
        )}
      </DialogContent>
      {dialogActions && (
        <DialogActions sx={{ gap: '20px' }} {...dialogActionProps}>
          {!hideNegativeButton && (
            <Button
              {...negativeButtonProps}
              className={classes.saveBtn}
              onClick={() => {
                console.log('KenDialog: Negative Button Clikc');
                onNegativeButtonClick();
              }}
              color="primary"
              variant={negativeBtnType ? negativeBtnType : 'text'}
            >
              <Typography {...negativeButtonLabelProps}>{negativeButtonText || 'Cancel'}</Typography>
            </Button>
          )}
          {!hidePositiveButton && (
            <Button
              style={{ margin: '15px 15px' }}
              className={classes.nextBtn}
              onClick={() => {
                positiveButtonClick();
                setPositiveButtonClickChange(positiveButtonClickChange + 1);
              }}
              color="primary"
              variant="contained"
            >
              <Typography {...positiveButtonLabelProps}>{positiveButtonText || 'Ok'}</Typography>
            </Button>
          )}
        </DialogActions>
      )}
    </Dialog>
  );
}
